<template >
  <!-- 模版一 -->
  <div class="container" v-if="!!wechat">
    <i class="back" @click="back"></i>
    <div class="body">
      <header class="header">
        <span class="title">报名成功</span>
      </header>

      <div class="addWechat">
        <div class="addWechatTitle">-添加助教老师微信-</div>
        <div class="addWechatSubtitle">课前提醒课后答疑,专题学习互相帮助</div>

        <div class="addWechatTip">1.复制微信号</div>
        <div class="wechat">
          <span class="wechatValue">{{ wechat }}</span>
          <i class="wechatCopy" @click="copy">复制</i>
        </div>
        <div class="addWechatTip">2.点击下方按钮打开微信添加老师</div>
      </div>

      <div class="addWechat tips">
        <div class="tipsTitle">-家长必读-</div>
        <div class="tipsTip">
          1、若正式开课时间有任何变动，我们会在
          <br />
          <span>1、</span>第一时间通知您，添加老师微信。
        </div>
        <div class="tipsTip">2、您可以随时申请退款。</div>
        <div class="tipsTip">3、若有任何问题，课随时联系班主任老师。</div>
      </div>

      <footer class="addTeacher" @click="addTeacher">打开微信添加老师</footer>
    </div>
  </div>

  <!-- 模版二 -->
  <div class="container" v-else>
    <titleBar title="支付成功"></titleBar>
    <div class="payBody">
      <div class="sucess_word">
        <i></i>
        支付成功
      </div>
      <div class="payLogo"></div>
      <div class="payTips">
        助教老师会尽快联系您，请保持
        <span>手机畅通</span>哦～
      </div>
    </div>
  </div>
</template>


<script>
import utils from "@/assets/js/utils";
import titleBar from "@/components/common/fit_iphonex/titleBar_fit_iphonex.vue";

export default {
  data() {
    return {
      wechat: false
    };
  },

  components: {
    titleBar
  },

  methods: {
    back() {
      location.href = "hybird://method/exit";
    },

    copy() {
      console.log("copy");
      location.href = `hybird://method/copy2Clipboard?content=${
        this.wechat
      }&toast=${encodeURIComponent("微信号已复制")}`;
    },

    addTeacher() {
      console.log("addTeacher");
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        location.href = `hybird://method/openBrowser?url=${encodeURIComponent(
          "weixin://"
        )}`;
      }, 500);
    },

    init() {
      this.timer = null;
    }
  },

  created() {
    const source = utils.getQueryString("source");
    const version = utils.getQueryString("version");
    const wechat = utils.getQueryString("wechat") || "";
    const token = utils.getQueryString("token");
    const courseID = utils.getQueryString("courseId");

    function sendLog(actionCode) {
      utils.sendLog(
        {
          token,
          version,
          source,
          extensionJson: {
            courseID
          }
        },
        actionCode
      );
    }

    this.init();
    this.wechat = wechat && wechat != "undefined" ? wechat : null;
    sendLog("hzxx454");
    sendLog("hzxx455");
  }
};
</script>

<style scoped>
.container {
  position: relative;
  height: 100vh;
  background-color: #75c9ff;
  font-family: PingFangSC-Medium;
  overflow: hidden;
}

.container::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: constant(safe-area-inset-top);
  height: env(safe-area-inset-top);
  background-color: #fff;
  z-index: 9998;
}

.back {
  position: absolute;
  left: 0.35rem;
  top: 0.38rem;
  width: 0.38rem;
  height: 0.38rem;
  background: url("../../assets/images/back_white.png") 0 0 no-repeat;
  background-size: 100%;
}

.body {
  overflow: hidden;
  margin: 1rem auto 0;
  width: 6.9rem;
  height: 11.65rem;
  border-radius: 0.4rem;
  background-color: #fff;
}

.header {
  position: relative;
  margin: 0.28rem 0 0 0.5rem;
  height: 2rem;
  background: url("../../assets/images/pay_success_ele.png") 0 0 no-repeat;
  background-size: contain;
}

.title {
  position: absolute;
  left: 3.34rem;
  top: 0.87rem;
  color: #424243;
  font-size: 0.46rem;
}

.addWechat {
  margin: 0 auto 0.4rem;
  width: 5.94rem;
  height: 4.31rem;
  box-sizing: border-box;
  padding: 0.52rem 0;
  border-radius: 0.5rem;
  text-align: center;
  color: #424243;
  background-color: #fafafa;
}

.addWechatTitle {
  margin-bottom: 0.2rem;
  font-size: 0.34rem;
  line-height: 0.34rem;
}

.addWechatSubtitle {
  margin-bottom: 0.83rem;
  color: #919294;
  font-size: 0.24rem;
  line-height: 0.24rem;
  font-family: PingFangSC-Regular;
  height: 0.24rem;
}

.addWechatTip {
  margin-bottom: 0.2rem;
  font-size: 0.26rem;
  line-height: 0.26rem;
}

.wechat {
  margin-bottom: 0.54rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fbae0c;
  height: 0.44rem;
}

.wechatValue {
  font-size: 0.32rem;
}

.wechatCopy {
  margin-left: 0.2rem;
  color: #fff;
  width: 0.84rem;
  height: 0.44rem;
  border-radius: 0.22rem;
  background-color: #fbae0c;
  line-height: 0.44rem;
}

.tips {
  height: 2.98rem;
  padding: 0.32rem 0.58rem;
  text-align: left;
}

.tipsTitle {
  margin-bottom: 0.36rem;
  color: #424243;
  text-align: center;
  font-size: 0.3rem;
  line-height: 0.3rem;
}

.tipsTip {
  margin-bottom: 0.15rem;
  font-size: 0.24rem;
  line-height: 0.3rem;
  color: #5f6162;
}

.tipsTip span {
  opacity: 0;
}

.addTeacher {
  margin: 0 auto;
  width: 3.94rem;
  height: 1rem;
  background-color: #ff7575;
  border-radius: 0.5rem;
  text-align: center;
  font-size: 0.32rem;
  color: #fff;
  line-height: 1rem;
}

/* 模版一 */
.payBody {
  padding-top: 2.4rem;
  height: 100%;
  background-color: #f8f9fd;
}
.sucess_word {
  height: 0.5rem;
  line-height: 0.5rem;
  text-align: center;
  font-family: PingFangSC-Medium;
  font-size: 0.38rem;
  color: #21bd0a;
}

.sucess_word i {
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  background: url("../../assets/images/pay_sucess_icon.png") 0 0 no-repeat;
  background-size: 100%;
  vertical-align: text-bottom;
}

.payLogo {
  margin: 1.4rem auto 0;
  width: 2.75rem;
  height: 2.5rem;
  background: url("../../assets/images/pay_success_ele02.png") 0 0 no-repeat;
  background-size: 100%;
}

.payTips {
  margin-top: 0.48rem;
  text-align: center;
  color: #aeadad;
  line-height: 0.28rem;
  font-size: 0.28rem;
  font-family: PingFangSC-Regular;
}

.payTips span {
  color: #43a5f3;
}

/*iPhone X XS 2436x1125px at 458ppi */
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .container {
    padding-top: constant(safe-area-inset-top);
  }
}

/*iPhone XR 1792x828px at 326ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  .container {
    padding-top: constant(safe-area-inset-top);
  }
}

/* iPhone XS Max 2688x1242px at 458ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .container {
    padding-top: constant(safe-area-inset-top);
  }
}
</style>


